import { useContext, useEffect, useState, useMemo, FormEvent } from 'react';
import { AdminContext } from '../contexts/AdminContext';
import { useSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Checkbox, TextField, Dialog, DialogTitle, DialogContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, IconButton, Typography, Toolbar, Tooltip, TableSortLabel, Grid, Stack, Button, Autocomplete } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { country_options } from '../data/countries';
import { UserSearchQuery } from '../interfaces/UserInterfaces';
import { COSMOS_API, POST_ENDPOINT } from "../api/API";
import TableDisplayComponent from './TableDisplay';
interface HeadCell {
  disablePadding: boolean;
  id: string;
  label: string;
  numeric: boolean;
}

const columns: HeadCell[] = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'User Id',
  },
  {
    id: 'firstName',
    numeric: false,
    disablePadding: true,
    label: 'First Name',
  },
  {
    id: 'lastName',
    numeric: false,
    disablePadding: true,
    label: 'Last Name',
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    label: 'Email',
  }
];

const searchQueryEmpty = (query: UserSearchQuery) => {
  return !(query.email || query.country || query.firstName || query.lastName || query.organizationId || query.applicationId || query.userProvisionStatus);
}

const AddGroupMembers = (props: any) => {
  const searchInitialState = {
    email: "",
    country: "",
    firstName: "",
    lastName: "",
    organizationId: "",
    applicationId: "",
    userProvisionStatus: ""
  }
  const [pageMembers, setPageMembers] = useState<Array<any>>([]);
  const [selectedMembers, setSelectedMembers] = useState<Array<string>>([]);
  const [searchForm, setSearchForm] = useState<UserSearchQuery>(searchInitialState);
  const [activeSearch, setActiveSearch] = useState<UserSearchQuery>(searchInitialState);
  const { adminCredentials, getToken } = useContext(AdminContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [fetchUsersInProgress, setFetchUsersInProgress] = useState<boolean>(false);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [numResults, setNumResults] = useState<number>(0);
  const [groupMembers, setGroupMembers] = useState<Array<string>>([]);

  const resetSearch = () => {
    setSearchForm(searchInitialState);
  }

  const handleNewSearch = (e: any) => {
    e.preventDefault();
    let newActiveSearch = { ...searchForm };
    setActiveSearch(newActiveSearch);
    fetchMembers(newActiveSearch, rowsPerPage, 0);
  }

  const fetchMembers = async (searchForm: any, _rowsPerPage: number, _offset: number) => {
    var body: any = {
      count: _rowsPerPage,
      offset: _offset,
      user: {
        "country": searchForm.country,
        "email": searchForm.email,
        "firstName": searchForm.firstName,
        "lastName": searchForm.lastName,
        "emailVerificationFlag": false,
        "passwordResetFlag": false
      }
    }

    setFetchUsersInProgress(true);
    setPageMembers([]);
    const results = await COSMOS_API.POST(body, POST_ENDPOINT.SearchUsers, getToken());
    let newPageMembers: Array<any>;
    let newNumResults;
    let userResults = [];
    if (results.ok && results.respBody !== undefined && results.respBody !== null) {
      let _allUser = results.respBody.users.reduce((acc: any, user: any) => {
        acc = [...acc, { id: user.id, firstName: user.firstName, lastName: user.lastName, email: user.email }];
        return acc;
      }, []);
      newPageMembers = [..._allUser];
      newNumResults = results.respBody.numResults
      userResults = [..._allUser];
    } else {
      newPageMembers = [];
      newNumResults = 0;
    }
    if (userResults.length > 0) {
      const groupMembershipBody = {
        userIds: results.respBody.users.map((user: any) => user.id),
        groupId: props.groupId
      }
      const groupMembershipResults = await COSMOS_API.POST(groupMembershipBody, POST_ENDPOINT.GetUserGroupMemberships, getToken());
      if (groupMembershipResults.ok && groupMembershipResults.respBody) {
        setGroupMembers(Object.keys(groupMembershipResults.respBody).filter(userId => groupMembershipResults.respBody?.[userId]));
      }
    }
    setPageMembers(newPageMembers);
    setNumResults(newNumResults);
    setFetchUsersInProgress(false);
  }

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    fetchMembers(activeSearch, rowsPerPage, newPage*rowsPerPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    let _rowsPerPage = parseInt(event.target.value, 10); 
    setRowsPerPage(_rowsPerPage);
    setPage(0);
    fetchMembers(activeSearch, _rowsPerPage, page*_rowsPerPage);
  };


  return (
    <>
      <Dialog open={props.openAddMembersPopup} component={"div"} maxWidth={'md'} fullWidth={true}>
        <DialogTitle>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Search / Add Users
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>

        </DialogTitle>
        <DialogContent >
          <div>
            <Grid container flexDirection={"row"} spacing={2} sx={{ marginBlock: '10px' }}>
              <Grid container item direction={"column"} gap={2} xs={6}>
                <Grid >
                  < TextField
                    label="Email Address"
                    name="email"
                    className="filter-input"
                    value={searchForm.email}
                    onChange={e => setSearchForm({ ...searchForm, email: e.target.value })}
                    fullWidth
                    size='small'
                  />
                </Grid>

                <Grid >
                  <Autocomplete
                    disablePortal
                    sx={{ backgroundColor: "white" }}
                    value={searchForm.country !== '' || searchForm.country === undefined ? country_options.find(option => option.value === searchForm.country) : null}
                    options={country_options}
                    renderInput={(params) => <TextField {...params} label="Country" />}
                    onChange={(event: any, value: { value: string, label: string } | null) => {
                      value !== null ? setSearchForm({ ...searchForm, country: value.value }) : null
                    }}
                    fullWidth
                    size='small'
                  />
                </Grid>
              </Grid>
              <Grid container item direction={"column"} gap={2} xs={6}>
                <Grid >
                  < TextField
                    label="First Name"
                    name="firstName"
                    placeholder="Search first name"
                    className="filter-input"
                    value={searchForm.firstName}
                    onChange={e => setSearchForm({ ...searchForm, firstName: e.target.value })}
                    fullWidth
                    size='small'
                  />
                </Grid>
                <Grid >
                  < TextField
                    label="Last Name"
                    name="lastName"
                    placeholder="Search Lastname"
                    className="filter-input"
                    value={searchForm.lastName}
                    onChange={e => setSearchForm({ ...searchForm, lastName: e.target.value })}
                    fullWidth
                    size='small'
                  />
                </Grid>
              </Grid>


            </Grid>
            <Stack direction="row" spacing={2} justifyContent={'flex-end'} sx={{ my: '10px' }}>
              <Button variant='contained' disabled={searchQueryEmpty(searchForm)}  onClick={handleNewSearch}>
                Search
              </Button>
              <Button variant='outlined' onClick={resetSearch}>
                Clear
              </Button>
            </Stack>
          </div>
          {pageMembers.length == 0 && fetchUsersInProgress && <>Fetching users </>}
          {pageMembers.length > 0 &&
            <Box sx={{ width: '100%' }}>
              <Paper sx={{ width: '100%', mb: 2 }}>
                <TableDisplayComponent
                  members={pageMembers}
                  selectedMembers={selectedMembers}
                  handleAction={props.handleAddMembersToGroup}
                  columns={columns}
                  tableTitle="Search Results"
                  actionIcon={<Tooltip title="Add Members" >
                    <IconButton>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>}
                  disabledMembers={groupMembers}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  enableAction={props.adminWritable}
                />
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={numResults}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper></Box>

          }
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddGroupMembers;